import {stringify} from 'qs'
import request from 'message-control/utils/request'
import api from 'message-control/common/api/message-history'

export async function chatList(params) {
    return request(`${api.chatList.url}?${stringify(params)}`)
}

export async function groupChatList(params) {
    return request(`${api.groupChatList.url}?${stringify(params)}`)
}

export async function groupMembers(params) {
    return request(`${api.groupMembers.url}?${stringify(params)}`)
}
